import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { HeaderBarItem, HeaderBarDropdown, HeaderUtilityBar, makeStyles } from '@ellucian/react-design-system/core';
import { useIntl } from 'react-intl';
import GlobalLocaleContext from './GlobalLocaleContext';
import Icon from '@ellucian/ds-icons/lib/es6/Icon';
import { getDisplayForLocale } from '../Helpers/messagesHelpers';
import useRoot from '../RootContext/useRoot';

const useStyles = makeStyles((theme) => {
    const { globalTheme } = useRoot();
    return {
        utilityBarBackground: {
            backgroundColor: globalTheme?.bgimage ? 'transparent !important' : `${theme.palette.primary.dark} !important`,
        },
        themed: {
            '&, & a': {
                color: `${theme.palette.primary.contrastText} !important`,
            },
        },
    };
});

const GlobalLocaleHeaderItems = props => {
    const { isThemed = false } = props;
    const { formatMessage } = useIntl();
    const classes = useStyles();
    const globalLanguageCtx = useContext(GlobalLocaleContext);
    const { displayLocale, updateGlobalLocale } = globalLanguageCtx;
    let locales; 
    const tenant = window.PRELOADED_STATE;

    if (tenant.globalSettings.settingMessages.languages) {
        let result = Object.keys(tenant.globalSettings.settingMessages.languages).map(l => ({
            ...tenant.globalSettings.settingMessages.languages[l],
            key: l,
        }));
        result.sort(function(a,b) {
            let x = a.displayName.toLowerCase();
            let y = b.displayName.toLowerCase();
            return x < y ? -1 : x > y ? 1 : 0;
        });
        locales = result;
    }

    const updateLocale = useCallback((_, item) => { 
        updateGlobalLocale(item.value); 
    }, [updateGlobalLocale]);

    return (
        <>
            { locales && locales.length > 1 &&
                <HeaderUtilityBar className={classes.utilityBarBackground} isThemed={isThemed}>
                    <HeaderBarItem
                        itemKey="language-utility"
                        className={classes.themed}
                        isUtility
                    >
                        <HeaderBarDropdown
                            menuItems={locales?.map(locale => {
                                const localeDisplayLabel = getDisplayForLocale(locale.key, formatMessage);
                                return {
                                    key: locale.key,
                                    value: locale.key,
                                    label: localeDisplayLabel
                                };
                            })
                            }
                            dropdownMenuLabel={<Icon name="globe" />}
                            secondaryDropdownMenuLabel={formatMessage({id: 'globalLocaleLanguages'})}
                            onMenuItemClick={updateLocale}
                            menuHeader={
                                formatMessage(
                                    {id: 'globalLocaleLanguageSelection'}, 
                                    {language: displayLocale}
                                )
                            }
                        />
                    </HeaderBarItem>
                </HeaderUtilityBar>
            }
        </>
    );
};
GlobalLocaleHeaderItems.propTypes = {
    isThemed: PropTypes.bool,
};
export default GlobalLocaleHeaderItems;
